<div class='errorMsgContainer'>
    <div class='main-msg'>{{noActiveRuleHeader}}</div>
    <div class='secondary-msg'>{{noActiveRuleMsg}}</div>
</div>